import React from 'react';
import {Container, Paragraph, Link, ButtonContainer, FooterButtonContainer, HeaderContainer} from './Download.styles';
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles";
import config from "../../../api/config";
import {LogoContainer} from "../../../components/TopBarRedesigned/TopBarRedesigned.styles";

const cordova = window?.cordova as any;

const Download: React.FC = () => {

    const isIos = window.cordova?.platformId === 'ios'
    const isAndroid = window.cordova?.platformId === 'android'

    const isNotSupported = !isIos && !isAndroid

    let href = `mailto:${config.CA.helpEmail}`

    if (isIos) {
        href = 'itms-apps://itunes.apple.com/ca/app/tempstars/id1094751710?mt=8'
    } else if (isAndroid) {
        href = 'market://details?id=ca.tempstars.app2'
    }

    const updateHandler = () => {
        cordova
            ? cordova.InAppBrowser.open(
                href,
                '_system',
                'location=yes'
            )
            : window.open(
                href,
                '_system',
                'location=yes'
            )
    }

    return (
        <Container>
            <HeaderContainer>
                <LogoContainer>
                    Update Required
                </LogoContainer>
            </HeaderContainer>

            <Paragraph>
                We continually improve TempStars based on your feedback.
                In that spirit, we just updated the app to improve your TempStars experience,
                so your current version no longer works.
            </Paragraph>
            <Paragraph>
                Just tap the button below to update your TempStars app to the new version.
            </Paragraph>

            <ButtonContainer>
                {isNotSupported ? (<>Unfortunately there is a problem - please<br/></>) : null}
                <StyledButton
                    variant="contained"
                    color="primary"
                    size="medium"
                    onClick={updateHandler}
                >
                    {isNotSupported ? 'Contact Support' : 'Update Now'}
                </StyledButton>
            </ButtonContainer>

            <Paragraph>
                If you run into a hitch, most problems can be resolved by completely removing the app from your mobile
                and re-installing it from your app store.
            </Paragraph>

            <Paragraph>
                If you're having issues logging in, please try clearing your cache and app/browser cookies first.
                If problems persist, don't hesitate to contact our support team for assistance.
            </Paragraph>

            <Paragraph>
                Please review our updated <Link className="link external" href="https://www.tempstars.ca/terms" target="_system">Terms
                of Service</Link> and <Link className="link external" href="https://www.tempstars.com/privacy" target="_system">Privacy
                Policy</Link>;
                using the app constitutes agreement with these terms and policies.
            </Paragraph>

            <FooterButtonContainer>
                <Link href={`mailto:${config.CA.helpEmail}`} className="external" target="_system">Contact Support</Link>
                <div className="row">
                    <div className="col-auto">
                        Copyright &copy; 2023 Sudden Turtle Dental Consulting, Inc.
                    </div>
                </div>
            </FooterButtonContainer>
        </Container>
    );
};

export default Download;